/**
 * Javascript replica of our pagination markup.
 * @param  {Number} maxNumPages The total number of pages.
 * @param  {Number} currentPage The current page.
 * @param  {Number} maxPages    The max amount of pages to show at one time.
 * @param  {String} classes     The classes for the pagination wrapper.
 */
export const emPagination = (maxNumPages, currentPage, maxPages = 10, classes = 'pagination') => {
	// If maxNumberPages equals 1 return immediately.
	if (maxNumPages === 1) {
		return '';
	}

	// Make sure current page is less than or equal to max page.
	if (currentPage < 1) {
		currentPage = 1;
	} else if (currentPage > maxNumPages) {
		currentPage = maxNumPages;
	}

	let startPage; let
		endPage;

	if (maxNumPages <= maxPages) {
		// If total less than max show all.
		startPage = 1;
		endPage = maxNumPages;
	} else {
		// Calculate the start and end pages.
		const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
		const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
		if (currentPage <= maxPagesBeforeCurrentPage) {
			// Current page is near the start.
			startPage = 1;
			endPage = maxPages;
		} else if (currentPage + maxPagesAfterCurrentPage >= maxNumPages) {
			// Current page is near the end.
			startPage = maxNumPages - maxPages + 1;
			endPage = maxNumPages;
		} else {
			// Current page is somewhere in the middle.
			startPage = currentPage - maxPagesBeforeCurrentPage;
			endPage = currentPage + maxPagesAfterCurrentPage;
		}
	}

	// Create an array of pages to loop through and create pagination markup.
	const pages = Array.from(Array((endPage + 1) - startPage).keys()).map((i) => startPage + i);

	// Set next and previous pages.
	const previousPage = startPage - 1;
	const nextPage = endPage + 1;

	let html = `<div class="${classes}">`;

	// if previous page > 0 show previous link.
	if (previousPage > 0) {
		html += `<span class="prev page-numbers" data-page="${previousPage}"><i class="fa fa-chevron-left" aria-hidden="true"></i></span>`;
	}

	// Loop through and set pages.
	pages.forEach((page) => {
		const isCurrent = currentPage === page;
		const current = isCurrent ? ' current' : '';
		const ariaCurrent = isCurrent ? 'aria-current="page"' : '';
		html += `<span ${ariaCurrent} class="page-numbers${current}" data-page="${page}">${page}</span>`;
	});

	// If next page less than or equal to max pages.
	if (nextPage <= maxNumPages) {
		html += `<span class="next page-numbers" data-page"${nextPage}"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>`;
	}

	return html;
};

/**
 * Load More Button.
 * @param  {Number} maxNumPages The total number of pages.
 * @param  {Number} currentPage The current page.
 * @param  {String} btnText     The load more button text.
 * @param  {String} classes     The button classes.
 * @return {string}             The button markup.
 */
export const emLoadMore = (maxNumPages, currentPage, btnText = 'Load More', classes = 'btn btn--style-primary has-primary-background-color load-more') => {
	const isEnabled = currentPage < maxNumPages;
	const page = isEnabled ? currentPage + 1 : 0;
	const disabled = !isEnabled ? 'disabled' : '';
	return `<button class="${classes}" data-page="${page}" ${disabled}>${btnText}</button>`;
};
